/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mockuser.vue?vue&type=template&id=9b2339ce&scoped=true"
import script from "./mockuser.vue?vue&type=script&lang=js"
export * from "./mockuser.vue?vue&type=script&lang=js"
import style0 from "./mockuser.vue?vue&type=style&index=0&id=9b2339ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2339ce",
  null
  
)

export default component.exports